import { render, staticRenderFns } from "./ThreadIntro.vue?vue&type=template&id=2992d5e4&scoped=true"
import script from "./ThreadIntro.vue?vue&type=script&lang=js"
export * from "./ThreadIntro.vue?vue&type=script&lang=js"
import style0 from "./ThreadIntro.vue?vue&type=style&index=0&id=2992d5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992d5e4",
  null
  
)

export default component.exports